import { TranslationRepository } from '../data/translation-repository';
import { TranslationsResponse, TranslationQueryParams } from '../types/translation-types';

export class GetTranslationsUseCase {
  constructor(private readonly repository: TranslationRepository) {}

  async execute(params: TranslationQueryParams): Promise<TranslationsResponse> {
    return this.repository.getTranslations(params);
  }
}
